import { createRouter, createWebHistory } from 'vue-router';
import Home from '../components/ReplaceSql.vue';

const routes = [
    {
        path: '/:lang(en|zh)',
        name: 'Home',
        component: Home,
        meta: {
            title: 'home',
            description: 'description'
        }
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/zh'
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

export default router;
